'use strict';

var BaseRouter = require('commons/routers/Base');

module.exports = BaseRouter.extend({
    initialize: function(options) {
        options = _.defaults(options || {}, {
            el: null
        });
        this.el = options.el;
    }
});



// WEBPACK FOOTER //
// ./app/employee/routers/Base.js